import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { CustomRating } from '@components/common/CustomRating';
import { PUBLIC_ROUTES } from 'src/constants/routes';
import { useStyles } from './styles';

const DEMO_REASON_DELAY_OPTIONS = [
  { id: 1, name: 'Cash flow' },
  { id: 2, name: 'Lack of urgency / behavioural' },
  { id: 3, name: 'Disputes' },
  { id: 4, name: 'Human error' },
  { id: 5, name: 'Admin issues' },
  { id: 6, name: 'Other' },
];

const DEMO_PAYMENT_RATING = 4;
const DEMO_BUSINESS_RATING = 4;

export const ShareExperience = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleContinue = () => {
    history.push(PUBLIC_ROUTES.REGISTER);
  };

  return (
    <Box className={classes.section}>
      <Box className={classes.layout}>
        <Box className={classes.textColumn}>
          <Typography className={classes.title} component="h2">
            Share your experience
          </Typography>
          <Typography className={classes.subtitle}>
            Help others decide who to work with. It takes less than 2 minutes.
          </Typography>
        </Box>
        <Box className={classes.columnDivider} aria-hidden />
        <Box className={classes.formCard}>
          <Box className={classes.demoFormFields}>
            <Box className={classes.searchField}>
              <Box className={classes.searchInputWrapper}>
                <SearchIcon className={classes.searchIcon} />
                <input
                  type="text"
                  className={classes.searchInput}
                  placeholder="Search or enter company name"
                  aria-label="Search or enter company name"
                  readOnly
                  tabIndex={-1}
                />
              </Box>
            </Box>
            <Box className={`${classes.dividerLine} ${classes.dividerAfterSearch}`} aria-hidden />
            <Box className={classes.ratingRow}>
              <Typography className={classes.fieldLabel}>Speed to pay</Typography>
              <Box className={classes.ratingStars}>
                <CustomRating
                  name="demo_payment_rating"
                  value={DEMO_PAYMENT_RATING}
                  precision={1}
                  onChange={() => {}}
                />
              </Box>
            </Box>
            <Box className={`${classes.dividerLine} ${classes.dividerBetweenSections}`} aria-hidden />
            <Box className={classes.reasonDelaysBlock}>
              <Typography className={classes.fieldLabel} style={{ marginBottom: 16 }}>
                Reason for delays (if any)
              </Typography>
              <Grid container>
                {DEMO_REASON_DELAY_OPTIONS.map(option => (
                  <Grid item xs={12} sm={6} key={option.id}>
                    <FormControlLabel
                      control={<Checkbox color="primary" checked={false} tabIndex={-1} />}
                      label={option.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Box className={`${classes.dividerLine} ${classes.dividerBetweenSections}`} aria-hidden />
            <Box className={classes.ratingRow}>
              <Typography className={classes.fieldLabel}>Ease of doing business:</Typography>
              <Box className={classes.ratingStars}>
                <CustomRating
                  name="demo_business_rating"
                  value={DEMO_BUSINESS_RATING}
                  precision={1}
                  onChange={() => {}}
                />
              </Box>
            </Box>
          </Box>
          <Box className={`${classes.dividerLine} ${classes.dividerBeforeContinue}`} aria-hidden />
          <Button
            color="primary"
            variant="contained"
            size="large"
            className={classes.continueButton}
            onClick={handleContinue}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
